import React from "react";
import { useTranslation } from "react-i18next";
import { CourseGrid } from "./CourseGrid";
import { EnrolledCourse } from "@/hooks/useEnrolledCourses";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface MyCoursesProps {
  courses: EnrolledCourse[];
  loading: boolean;
  lang?: string;
}

export function MyCourses({ courses, loading, lang = "en" }: MyCoursesProps) {
  const { t } = useTranslation();
  return (
    <div>
      <h2 className="text-2xl font-semibold mb-6">{t("my_courses")}</h2>
      {loading ? (
        <p>Loading...</p>
      ) : courses.length > 0 ? (
        <CourseGrid courses={courses} loading={loading} lang={lang} />
      ) : (
        <div className="text-center text-muted-foreground py-8">
          <p className="mb-4">{t("not_enrolled")}</p>
          <Button asChild><Link to={`/${lang === 'en' ? '' : lang + '/'}courses`}>{t("browse_courses")}</Link></Button>
        </div>
      )}
    </div>
  );
}
